<template>
    <div>
        <info-item
            :isEnabled="isEnabled"
            :label="resource('DmVisualizer_ChangeInfo_Logo')"
            @set-enabled="$emit('set-enabled', $event)"
        >
            <info-file-upload
                :isEnabled="isEnabled"
                @input="$emit('input', $event)"
            >
            </info-file-upload>
        </info-item>
    </div>
</template>

<script>

//Mixins
import resourceMixin from '../../../../Util/Mixins/resources';

//Components
import InfoItem from './InfoItem.vue';
import InfoFileUpload from './Components/InfoFileUpload.vue'

export default {
    name: 'info-logo',
    mixins: [resourceMixin],
    components: {
        InfoItem,
        InfoFileUpload
    },
    props: {
        isEnabled: {
            type: Boolean,
            required: true
        }
    }
}

</script>

<style scoped src="../../Style/info-logo.scss" lang="scss">
</style>
